<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			人员基础信息
		</div>
		<div class="operation">
			<a-button class="creatadd" type="primary" @click="addModal">
				创建人员
			</a-button>
			<div class="sinput">
				<input type="text" placeholder="请输入姓名查询" />
				<img src="../../assets/image/37.png" />
			</div>
		</div>
		<a-table :columns="columns" :data-source="data">
			<span slot="tags" slot-scope="text,tags">
				<a class="edit_btn" @click="() => editModal(tags)">编辑</a>
				<a class="delete_btn" @click="() => deleteBtn(tags)">删除</a>
			</span>
		</a-table>

		<!-- 添加弹窗 -->
		<div class="addbox" ref="add">
			<a-modal v-model="visible" :title="title" @ok="handleOk" :getContainer="()=>$refs.add" okText="确认"
				cancelText="取消" width='490px'>
				
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="3" :order="1">
							<div class="frame_list_title" style="padding-left: 13px;">
								姓名
							</div>
						</a-col>
						<a-col :span="10" :order="2">
							<a-input type="text" style="width: 150px;" v-model='projectForm.name' />
						</a-col>
						
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="3" :order="1">
							<div class="frame_list_title" style="padding-left: 13px;">
								邮箱
							</div>
						</a-col>
						<a-col :span="10" :order="2">
							<a-input type="text" style="width: 150px;" v-model='projectForm.email' />
						</a-col>
						
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="3" :order="1">
							<div class="frame_list_title">
								手机号
							</div>
						</a-col>
						<a-col :span="10" :order="2">
							<a-input type="text" style="width: 150px;" v-model='projectForm.phone' />
						</a-col>
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="3" :order="1">
							<div class="frame_list_title" style="padding-left: 13px;">
								组别
							</div>
						</a-col>
						<a-col :span="16" :order="2">
							<a-select :default-value="projectForm.type" style="width: 180px" @change="handleChange">
								<a-select-option v-for="(item,index) in formType" :key='index' :value="item.value">
									{{item.name}}
								</a-select-option>
							</a-select>
						</a-col>
					</a-row>
				</div>
				
			</a-modal>
		</div>

	</div>
</template>

<script>
	const columns = [{
			title: '序号',
			dataIndex: 'id',
			align: 'center',
		},
		{
			title: '姓名',
			dataIndex: 'name',
			align: 'center',
		},
		{
			title: '手机号',
			dataIndex: 'phone',
			align: 'center',
		},
		{
			title: '邮箱',
			dataIndex: 'email',
			align: 'center',
		},
		{
			title: '组别',
			dataIndex: 'division',
			align: 'center',
		},
		{
			title: '创建时间',
			dataIndex: 'creatime',
			align: 'center',
		},
		{
			title: '操作',
			dataIndex: 'tags',
			scopedSlots: {
				customRender: 'tags'
			},
			align: 'center',
			width: '120px'
		},
	];

	const data = [{
			id: '1',
			name: '张三',
			phone: '1311234576',
			email: '11@qq.com',
			division: '一组',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '2',
			name: '张三',
			phone: '1311234576',
			email: '11@qq.com',
			division: '一组',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '3',
			name: '张三',
			phone: '1311234576',
			email: '11@qq.com',
			division: '一组',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '4',
			name: '张三',
			phone: '1311234576',
			email: '11@qq.com',
			division: '一组',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '5',
			name: '张三',
			phone: '1311234576',
			email: '11@qq.com',
			division: '一组',
			creatime: '2021-01-08 13:58:03',
		},
	];

	export default {
		data() {
			return {
				data, //表格内容
				columns, //表格头部
				temporary: [{
						id: '1',
						name: '张三',
						phone: '1311234576',
						email: '11@qq.com',
						division: '一组',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '2',
						name: '张三',
						phone: '1311234576',
						email: '11@qq.com',
						division: '一组',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '3',
						name: '张三',
						phone: '1311234576',
						email: '11@qq.com',
						division: '一组',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '4',
						name: '张三',
						phone: '1311234576',
						email: '11@qq.com',
						division: '一组',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '5',
						name: '张三',
						phone: '1311234576',
						email: '11@qq.com',
						division: '一组',
						creatime: '2021-01-08 13:58:03',
					},
				],
				visible: false,
				title: '', //弹框表提
				projectForm: {
					type: 0, //类型
					name: '', //姓名
					phone: '', //手机号
					email: '', //邮箱
					division: '', //组别
				},
				formType: [{
						name: '选项1',
						value: 0
					},
					{
						name: '选项2',
						value: 1
					},
					{
						name: '选项3',
						value: 2
					},
				]
			};
		},
		methods: {
			addModal(e) {
				console.log(e)
				this.data = this.temporary
				Object.keys(this.projectForm).forEach(
					(key) => (this.projectForm[key] = "")
				);
				this.title = '创建人员'
				this.visible = true;
			},
			editModal(tags) {
				console.log(tags)
				var data = tags
				this.projectForm = data
				this.title = '编辑人员'
				this.visible = true;
			},
			handleOk(e) {
				this.visible = false;
			},
			handleChange(value) {
				console.log(value); // { key: "lucy", label: "Lucy (101)" }
			},
		},

	};
</script>

<style>
	@import url("../../assets/css/common.css");

	.edit_btn {
		float: left;
		color: #7F86E9;
		font-size: 12px;
		padding: 0 10px;
		text-decoration: underline;
	}

	.delete_btn {
		color: #999999;
		font-size: 12px;
		padding-right: 10px;
		text-decoration: underline;

	}
</style>
